import React, { Component } from 'react';
import './header.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';

class Header extends Component {
    render() {
      return (
        <React-Fragment>
            <header>
                <LazyLoadImage src={`cover/cover-${Math.round(Math.random() * (+3 - +1) + 1)}.png`} height="220px" effect="opacity" placeholderSrc={`placeholders/empty.jpg`} delayTime="1000" threshold="200"  />
            </header>
        </React-Fragment>
      );
    }
  }
  
  export default Header;